module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"three","commonjs2":"three","root":"THREE"}
// module id = 0
// module chunks = 0 1